import React, { useState, useEffect, useContext } from "react";

import lbl from "../../data/Labels.json";
import db from "../../services/query";

import PrintHeader from "./common/PrintHeader";
import PrintBodyTitle from "./common/PrintBodyTitle";
import PrintTable from "./common/PrintTable";

import { HalfYearContext } from "../../contexts/halfYearContext";

const AccountsReport = () => {
  let printHeadTexts = ["معاونیت امور مالی و اداری", "مدیریت مالی"];
  const [tableTitles, setTableTitles] = useState({ mainTitle: "گزارش حسابات" });

  const { halfYear } = useContext(HalfYearContext);

  const columns = [
    { path: "id", label: "شماره" },
    { path: "name", label: "حساب" },
    { path: "fee_received", label: "فیس" },
    { path: "revenue_received", label: "سایر درآمدها" },
    { path: "debt_paid", label: "بدهی" },
    { path: "expense_paid", label: "مصارف" },
    { path: "teacher_salary_paid", label: "معاشات استادان" },
    { path: "staff_salary_paid", label: "معاشات کارمندان" },
    { path: "total_received", label: "مجموع دریافت" },
    { path: "total_paid", label: "مجموع پرداخت" },
    { path: "balance", label: "باقیمانده" },
    { path: "option" },
  ];

  const [data, setData] = useState([]);

  useEffect(() => {
    requestData();

    return () => setData([]);
  }, []);

  const requestData = async (p = new Object()) => {
    try {
      let query = `accounts?halfYearId=${halfYear}`;

      await db.getAll(query).then(({ data }) => {
        setData(data);
      });
    } catch ({ response }) {
      setData(response);
    }
  };

  return (
    <main className="main-print-wrapper accounts-report-print">
      <PrintHeader
        title={tableTitles.mainTitle}
        printHeadTexts={printHeadTexts}
      />
      <PrintBodyTitle title={[]} />
      <PrintTable columns={columns} data={data} />
    </main>
  );
};

export default AccountsReport;
